import React from 'react';
import { bool, func, object, node } from 'prop-types';
import Modal from 'library/components/modal';
import { BaseModalBody } from 'apps/journey/components/widgets/targets-report/styled-targets-report-base-modal';

const BaseModal = ({ active, toggleActive, modalStyle, children }) => {
  const handleToggle = () => {
    toggleActive(!active);
  };

  return (
    <Modal active={active} onClose={handleToggle}>
      <BaseModalBody active={active} modalStyle={modalStyle}>
        {children}
      </BaseModalBody>
    </Modal>
  );
};

BaseModal.propTypes = {
  active: bool,
  toggleActive: func,
  children: node,
  modalStyle: object,
};

export default BaseModal;
